// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';

import sparklyBackground from '@jane/shared/assets/sparkly-background.svg';

export const Background = styled.div<{
  hideBranding: boolean;
  sparkly: boolean;
}>(({ hideBranding, sparkly, theme }) => ({
  ...(sparkly && {
    background: `url("${sparklyBackground}")`,
    backgroundSize: 'cover',
  }),
  backgroundColor: sparkly
    ? 'none'
    : hideBranding
      ? theme.colors.primary.light
      : theme.colors.brand.purple.main,
  width: '100%',
  height: '100%',
}));
